import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/reddit-alien': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M440.3 203.5C425.3 203.5 412.1 209.7 402.4 219.4 366.7 194.7 318.6 178.8 265.3 177.1L293 52.3 381.2 72.1C381.2 93.7 398.8 111.3 420.4 111.3 442.4 111.3 460.1 93.2 460.1 71.6S442.5 31.9 420.4 31.9C405 31.9 391.7 41.2 385.1 53.9L287.7 32.3C282.8 31 278 34.5 276.7 39.4L246.3 177C193.4 179.2 145.8 195.1 110 219.8 100.3 209.7 86.6 203.5 71.6 203.5 16 203.5-2.2 278.1 48.7 303.6 46.9 311.5 46.1 319.9 46.1 328.3 46.1 412.1 140.5 480 256.4 480 372.8 480 467.2 412.1 467.2 328.3 467.2 319.9 466.3 311.1 464.1 303.2 514 277.6 495.6 203.5 440.3 203.5zM129.4 308.9C129.4 286.9 147 269.2 169.1 269.2 190.7 269.2 208.3 286.8 208.3 308.9 208.3 330.5 190.7 348.1 169.1 348.1 147.1 348.2 129.4 330.5 129.4 308.9zM343.7 402.4C307.3 438.8 204.6 438.8 168.2 402.4 164.2 398.9 164.2 392.7 168.2 388.7 171.7 385.2 177.9 385.2 181.4 388.7 209.2 417.2 301.4 417.7 330.4 388.7 333.9 385.2 340.1 385.2 343.6 388.7 347.7 392.7 347.7 398.9 343.7 402.4zM342.9 348.2C321.3 348.2 303.7 330.6 303.7 309 303.7 287 321.3 269.3 342.9 269.3 364.9 269.3 382.6 286.9 382.6 309 382.5 330.5 364.9 348.2 342.9 348.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/reddit-alien.js
// module id = J70N
// module chunks = 144